import {FC, ReactNode} from 'react';
import {createPortal} from 'react-dom';

const TooltipOverlay: FC<{children: ReactNode}> = ({children}) => {
  return createPortal(children, document.body);
};

export default TooltipOverlay;
